import { useState, useEffect } from 'react';

export type FieldMode = 'mobile' | 'tablet' | 'desktop';
export type CardSize = 'sm' | 'md' | 'lg';

export interface FieldLayout {
  mode: FieldMode;
  cardSize: CardSize;
  cardWidth: number;
  fieldViewBox: string;
  isVertical: boolean;
  sidebarWidth: number;
  nameMaxChars: number;
}

export function useFieldLayout(): FieldLayout {
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  if (width < 768) {
    return {
      mode: 'mobile',
      cardSize: 'sm',
      cardWidth: 56,
      fieldViewBox: '0 0 300 450',
      isVertical: true,
      sidebarWidth: 0,
      nameMaxChars: 8,
    };
  }

  if (width < 1024) {
    // Tablet: check orientation
    const isPortrait = window.innerHeight > window.innerWidth;
    return {
      mode: 'tablet',
      cardSize: 'md',
      cardWidth: 64,
      fieldViewBox: isPortrait ? '0 0 360 540' : '0 0 560 360',
      isVertical: isPortrait,
      sidebarWidth: isPortrait ? 0 : 240,
      nameMaxChars: 10,
    };
  }

  return {
    mode: 'desktop',
    cardSize: 'lg',
    cardWidth: 72,
    fieldViewBox: '0 0 560 380',
    isVertical: false,
    sidebarWidth: 280,
    nameMaxChars: 12,
  };
}
